define('lib/log-ajax-redirect/log-ajax-redirect',['require','exports','module','web-urls','api-access','lib/auth/auth','uuid'],function (require, exports, module) {
    var webUrls = require('web-urls');
    var apiAccess = require('api-access');
    var auth = require('lib/auth/auth');
    var uuid = require('uuid');

    var getUserKeyFromAccessToken = function () {
        try {
            var token = auth.getToken();
            var accessToken = token.access_token;
            var tokenPayload = accessToken.split('.')[1];
            var payload = JSON.parse(window.atob(tokenPayload));
            return payload.sub;
        } catch (e) {
            return null;
        }
    };

    module.exports = function (done) {
        return function (jqXHR, method, url) {
            // only log 403 errors
            var ignore = jqXHR.status !== 403;

            // prevent loop from logging call
            ignore = ignore || url === webUrls.get('loggingSvcUrl');

            if (ignore) {
                return done(jqXHR, method, url);
            }

            var data = {
                product: 'gotomeeting',
                entries: [{
                    module: 'log-ajax-redirect',
                    msg: 'Received a 403 which will result in a redirect',
                    status: 403,
                    method: method,
                    url: url,
                    ua: navigator.userAgent,
                    userKey: getUserKeyFromAccessToken(),
                    origin: window.location.href,
                    machineId: uuid.machineId,
                    timestamp: (new Date()).toISOString()
                }]
            };

            return apiAccess.logging.create(data).then(
                function onLogSuccess() {
                    return done(jqXHR, method, url);
                },
                function onLogFailure() {
                    return done(jqXHR, method, url);
                }
            );
        };
    };
});

